/*
 * Created by: cparaschiv
 * Date: 07.12.2012, 16:18
 */

/**
 * Contains core utilities used along the Adaptive Web framework.
 * @module TS
 * */

// Avoid `console` errors in browsers that lack a console (IE8, IE9 ...)
(function () {
    var method;
    var noop = function () {
    };
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

var TS = TS || {},
    ts = TS;
(function () {
    'use strict';

    var toString = Object.prototype.toString;
    Object.append(TS, {

        /**
         * <p>Returns true if the passed value is empty.</p>
         * <p>The value is deemed to be empty if it is<div class="mdetail-params"><ul>
         * <li>null</li>
         * <li>undefined</li>
         * <li>an empty array</li>
         * <li>a zero length string (Unless the <tt>allowBlank</tt> parameter is <tt>true</tt>)</li>
         * </ul></div>
         * @param {*} val The value to test
         * @param {Boolean} allowBlank (optional) true to allow empty strings (defaults to false)
         * @return {Boolean}
         * @static
         */
        isEmpty: function (val, allowBlank) {
            return val === null || val === undefined || ((TS.isArray(val) && !val.length)) || (!allowBlank ? val === '' : false);
        },

        /**
         * Returns true if the passed value is a JavaScript array, otherwise false.
         * @param {*} val The value to test
         * @return {Boolean}
         * @static
         */
        isArray: function (val) {
            return toString.apply(val) === '[object Array]';
        },

        /**
         * Returns true if the passed object is a JavaScript date object, otherwise false.
         * @param {*} val The object to test
         * @return {Boolean}
         * @static
         */
        isDate: function (val) {
            return toString.apply(val) === '[object Date]';
        },

        /**
         * Returns true if the passed value is a JavaScript Object, otherwise false.
         * @param {*} val The value to test
         * @return {Boolean}
         * @static
         */
        isObject: function (val) {
            return !!val && Object.prototype.toString.call(val) === '[object Object]';
        },

        /**
         * Returns true if the passed value is a JavaScript 'primitive', a string, number or boolean.
         * @param {*} val The value to test
         * @return {Boolean}
         * @static
         */
        isPrimitive: function (val) {
            return TS.isString(val) || TS.isNumber(val) || TS.isBoolean(val);
        },

        /**
         * Returns true if the passed value is a JavaScript Function, otherwise false.
         * @param {*} val The value to test
         * @return {Boolean}
         * @static
         */
        isFunction: function (val) {
            return toString.apply(val) === '[object Function]';
        },

        /**
         * Returns true if the passed value is a number. Returns false for non-finite numbers.
         * @param {*} val The value to test
         * @return {Boolean}
         * @static
         */
        isNumber: function (val) {
            return typeof val === 'number' && isFinite(val);
        },

        /**
         * Validates that a value is numeric.
         * @param {*} val Examples: 1, '1', '2.34'
         * @return {Boolean} True if numeric, false otherwise
         * @static
         */
        isNumeric: function (val) {
            return !isNaN(parseFloat(val)) && isFinite(val);
        },

        /**
         * Returns true if the passed value is a string.
         * @param {*} val The value to test
         * @return {Boolean}
         * @static
         */
        isString: function (val) {
            return typeof val === 'string';
        },

        /**
         * Returns true if the passed value is a boolean.
         * @param {*} val The value to test
         * @return {Boolean}
         * @static
         */
        isBoolean: function (val) {
            return typeof val === 'boolean';
        },

        /**
         * Returns true if the passed value is an HTMLElement
         * @param {*} val The value to test
         * @return {Boolean}
         * @static
         */
        isElement: function (val) {
            return val ? !!val.tagName : false;
        },

        /**
         * Returns true if the passed value is not undefined.
         * @param {*} val The value to test
         * @return {Boolean}
         * @static
         */
        isDefined: function (val) {
            return typeof val !== 'undefined';
        },

        /**
         * Returns the first argument if it has a defined value or the default value (second argument).
         * @param {*} val The value to test
         * @param {*} defaultValue The default value
         * @returns {*}
         * @static
         *
         * @example
         *
         * var person = { age: 35, gender: 'F' };
         * var personName = TS.ifNotDefined(person.name, 'Jane Doe');
         * console.log('Hi ' + personName); // Hi Jane Doe
         */
        ifNotDefined: function (val, defaultValue) {
            return TS.isDefined(val) ? val : defaultValue;
        },

        /**
         * Returns true if the passed value is not undefined or null.
         * @param {*} val The value to test
         * @return {Boolean}
         * @static
         */
        hasValue: function (val) {
            return typeof val !== 'undefined' && val !== null;
        },

        /**
         * Creates namespaces to be used for scoping variables and classes so that they are not global.
         * Specifying the last node of a namespace implicitly creates all other nodes.
         * @param {String} namespace1
         * @param {String} namespace2
         * @param {String} etc
         * @return {Object} The namespace object. (If multiple arguments are passed, this will be the last namespace created)
         * @example
         * TS.namespace('Company.data');
         * Company.Widget = function() { ... }
         * Company.data.CustomStore = function(config) { ... }
         * @static
         */
        namespace: function () {
            var len1 = arguments.length,
                i = 0,
                len2,
                j,
                main,
                ns,
                sub,
                current;

            for (; i < len1; ++i) {
                main = arguments[i];
                ns = arguments[i].split('.');
                current = window[ns[0]];
                if (current === undefined) {
                    current = window[ns[0]] = {};
                }
                sub = ns.slice(1);
                len2 = sub.length;
                for (j = 0; j < len2; ++j) {
                    current = current[sub[j]] = current[sub[j]] || {};
                }
            }
            return current;
        },

        /**
         * Copies all the properties of config to the specified object.
         * @param {Object} obj The receiver of the properties
         * @param {Object} cfg The source of the properties
         * @return {Object} The object passed as argument.
         * @method
         * @static
         */
        extend: function (obj) {
            obj = obj || {};
            for (var i = 1, l = arguments.length; i < l; i++) {
                var extended = arguments[i] || {};
                for (var key in extended) {
                    obj[key] = extended[key];
                }
            }
            return obj;
        },

        /**
         * Enumerates over an array or an object.
         * Returning <code>false</code> from the callback function stops the enumeration.
         * @param obj {Array|Object}
         * @param callback {Function} Callback to be executed for each item in the enumeration.
         * @return {Array|Object} The object passed as parameter (useful for call chaining).
         * @method
         * @static
         *
         * @example
         *
         * var fruits = ['apple', 'orange', 'rotten', 'banana'];
         * TS.each(fruits, function(i, fruit){
         *      if (fruit === 'rotten') return false; //breaks the loop
         *      TS.log('Fruit ' + i + ': ' + fruit);
         * });
         * // Output:
         * // Fruit 0: apple
         * // Fruit 1: orange
         *
         * var config = {
         *      background: 'white',
         *      foreground: 'black',
         *      button: 'unknown',
         *      border: 'red'
         * };
         * TS.each(config, function(key, color){
         *      if (color === 'unknown') return false; //breaks the loop
         *      TS.log(key + ' color: ' + color);
         * });
         * // Output:
         * // background color: white
         * // foreground color: black
         */
        each: function (obj, callback) {
            var value,
                i = 0,
                length = obj.length,
                isArray = Object.prototype.toString.call(obj) === '[object Array]';

            if (isArray) {
                for (; i < length; i++) {
                    value = callback.call(obj[i], i, obj[i]);
                    if (value === false) {
                        break;
                    }
                }
            } else {
                for (i in obj) {
                    value = callback.call(obj[i], i, obj[i]);
                    if (value === false) {
                        break;
                    }
                }
            }

            return obj;
        },

        /**
         * Creates an observable property for an object, with an optional default value.
         * @param object {Object} Target object
         * @param prop {String} Property name
         * @param [defaultValue] {*} Default value
         * @static
         *
         * @example
         *
         * var person = {};
         *
         * TS.wrap(person, 'firstName', '');
         *
         * me.watchProperty(person.firstName, function(newValue){
		 *      console.log('firstName changed to: ' + newValue);
		 * });
         *
         */
        wrap: function (object, prop, defaultValue) {
            if (!object.hasOwnProperty(prop) || object[prop] === undefined) {
                object[prop] = defaultValue;
            }
            object[prop] = ko.observable(object[prop]);
        },

        /**
         * Returns the value of an observable or the value itself if the passed parameter is not an observable.
         * Shorthand for <code>ko.utils.unwrapObservable</code>.
         * @method
         * @static
         */
        unwrap: ko.utils.unwrapObservable,

        /**
         * Returns true if the passed parameter an observable.
         * Shorthand for <code>ko.isObservable</code>.
         * @method
         * @static
         */
        isObservable: ko.isObservable,

        getParentWindow: function (element, defaultParent) {
            var containers = $(element).parents("[data-role='window']");
            if (!containers.length) {
                defaultParent = defaultParent || window;
                containers = $(defaultParent);
            }
            return $(containers[0]);
        },

        topFloatingElement: function (selector) {
            var elements = $(selector),
                floatingTopElementsKeyName = 'floating-top-elements',
                floatingOriginalTopOffsetsKeyName = 'floating-original-top-offsets',
                floatingTopOffsetsKeyName = 'floating-top-offsets',
                floatingRelativeTopOffsetsKeyName = 'floating-relative-top-offsets',
                floatingMinTopOffsetKeyName = 'floating-min-top-offset',
                floatingTopKeyName = 'floating-top';

            function getTopOffset(parentWindow, element, relative) {
                var parent = element;
                parentWindow = $(parentWindow);
                for (
                    var offsetTop = 0;
                    parent != null && !parentWindow.is(parent) && (!relative || $(parent).is(element) || $(parent).css('position') != 'relative');
                    offsetTop += parent.offsetTop, parent = parent.offsetParent
                );
                if (!relative || parent)
                    return offsetTop;
                return element.offsetTop;
            }

            function addFloatingTopElement(element) {
                var parentWindow = TS.getParentWindow(element)[0],
                    floatingElements = $.data(parentWindow, floatingTopElementsKeyName),
                    floatingTopOffsets = $.data(parentWindow, floatingTopOffsetsKeyName),
                    floatingOriginalTopOffsets = $.data(parentWindow, floatingOriginalTopOffsetsKeyName),
                    floatingRelativeTopOffsets = $.data(parentWindow, floatingRelativeTopOffsetsKeyName);
                if (!floatingElements) {
                    floatingElements = [];
                    $.data(parentWindow, floatingTopElementsKeyName, floatingElements);
                    floatingTopOffsets = [];
                    $.data(parentWindow, floatingTopOffsetsKeyName, floatingTopOffsets);
                    floatingOriginalTopOffsets = [];
                    $.data(parentWindow, floatingOriginalTopOffsetsKeyName, floatingOriginalTopOffsets);
                    floatingRelativeTopOffsets = [];
                    $.data(parentWindow, floatingRelativeTopOffsetsKeyName, floatingRelativeTopOffsets);

                    $(parentWindow).scroll(function () {
                        var windowTopOffset = ($(parentWindow).offset() || {}).top || 0,
                            scrollTop = $(parentWindow).scrollTop(),
                            minTopOffset = $.data(parentWindow, floatingMinTopOffsetKeyName) || 0,
                            offsets = $.data(parentWindow, floatingTopOffsetsKeyName),
                            originalOffsets = $.data(parentWindow, floatingOriginalTopOffsetsKeyName),
                            relativeOffsets = $.data(parentWindow, floatingRelativeTopOffsets),
                            elements = $.data(parentWindow, floatingTopElementsKeyName);

                        function resetFloatingOffsets(index, element, isFloating) {
                            $.data(element, floatingTopKeyName, isFloating);
                            for (var i = index + 1; i < elements.length; i++) {
                                offsets[i] = getTopOffset(parentWindow, elements[i]);
                            }
                        }

                        $.each(elements, function (index, element) {
                            var floatingTop = $.data(element, floatingTopKeyName) || false,
                                testScrollTop = scrollTop,
                                top = (scrollTop - offsets[index]) + (originalOffsets[index] - minTopOffset) + relativeOffsets[index],
                                $element = $(element);
                            floatingTop && (testScrollTop += $element.height());
                            if (testScrollTop >= offsets[index] && top > 0) {
                                $element.addClass('floating-top');
                                $element.css('top', top);
                                !floatingTop && resetFloatingOffsets(index, element, true);
                            }
                            else {
                                $element.removeClass('floating-top');
                                $element.css('top', '');
                                floatingTop && resetFloatingOffsets(index, element, false);
                            }
                        });
                    });
                }

                if (floatingElements.indexOf(element) === -1) {
                    var minTopOffset = $.data(parentWindow, floatingMinTopOffsetKeyName) || 1000000,
                        relativeTopOffset = getTopOffset(parentWindow, element, true),
                        topOffset = getTopOffset(parentWindow, element);
                    (topOffset < minTopOffset) && ($.data(parentWindow, floatingMinTopOffsetKeyName, topOffset));
                    floatingTopOffsets.push(topOffset);
                    floatingOriginalTopOffsets.push(topOffset);
                    floatingRelativeTopOffsets.push(relativeTopOffset);
                    floatingElements.push(element);                    
                }
            }

            elements.each(function (index, element) {
            	addFloatingTopElement(element);
            	var $element = $(element);
            	//for popups, at this stage the windows is not shown yet and outerHeight is 0
            	setTimeout(function () {
            		$element.parent('.fixed-height').height($element.outerHeight());
            	}, 0);
            });
        },

        getWidgets: function (parent) {
            var widgets = [];
            $(parent).find('[data-role]').each(function () {
                var $element = $(this),
                    role = $element.attr('data-role'),
                    widget = kendo.ui.roles[role];
                if (widget) {
                    widgets.push($element["getKendo" + widget.fn.options.name]());
                }
            });
            return widgets;
        },

        toggleNavBars: function (e) {
            TS.getParentWindow(e.target, window.body).find('.nav-block-float').toggleClass('show');
        },

        htmlEncode: function (value) {
            //create a in-memory div, set it's inner text(which jQuery automatically encodes)
            //then grab the encoded contents back out.  The div never exists on the page.
            return $('<div/>').text(value).html();
        }
    });

    /**
     * Shorthand for TS.namespace
     * @type function
     * @lends TS
     */
    TS.ns = TS.namespace;
    TS.data = {};
    TS.viewModel = {};
})();

$(document).on('focus', '.k-input', function () {
    var input = $(this);

    clearTimeout(input.data("selectTimeId")); //stop started time out if any
    var widget = input.data("kendoNumericTextBox");

    var selectTimeId = setTimeout(function () {
        input.select();
        if (widget !== undefined && input.val() !== "") {
            var format = widget._format(widget.options.format);
            var decimals = widget.options.decimals;

            if (decimals > 0) {
                var inputValue = input.val();
                var digits = inputValue.split(format["."]);

                if (digits.length == 1)
                    inputValue = inputValue + format["."];

                var l = digits[0].length + 1 + decimals;
                while (inputValue.length < l)
                    inputValue = inputValue + "0";

                input.val(inputValue);
                input.select();
            }
        }
    });

    input.data("selectTimeId", selectTimeId);
});

$(document).on('blur', '.k-input', function () {
    clearTimeout($(this).data("selectTimeId")); //stop started timeout
});
